module.exports = __webpack_public_path__ + "img/ic_pay1.1436fc81.png";